/**
 * Toggle switch — gold track when on, tonal track when off. The whole control is
 * a 48px-tall hit target so it stays tappable on mobile/PWA.
 */
export default function Switch({
  checked = false,
  onChange,
  disabled = false,
  label,
  id,
  className = "",
}) {
  return (
    <button
      type="button"
      role="switch"
      id={id}
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => onChange?.(!checked)}
      className={`relative inline-flex min-h-[48px] w-14 flex-shrink-0 items-center rounded-full px-1 transition-colors duration-200 disabled:opacity-50 ${className}`}
    >
      <span
        className={`absolute inset-y-0 left-0 my-auto h-7 w-14 rounded-full transition-colors duration-200 ${
          checked ? "gold-gradient" : "bg-surface-container-highest"
        }`}
        aria-hidden="true"
      />
      <span
        aria-hidden="true"
        className={`relative z-10 h-5 w-5 rounded-full bg-white shadow-ambient-sm transition-transform duration-200 ${
          checked ? "translate-x-7" : "translate-x-0"
        }`}
      />
    </button>
  );
}
